/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorTextPrimary = "#FFFFFF";
export const ColorTextSecondary = "#FFFFFF";
export const ColorBackgroundPrimary = "#08009D";
export const ColorIconPrimary = "#FFFFFF";
export const ColorIconSecondary = "#FFFFFF";
